import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getVehicleAccidentCategories = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.VehicleAccident}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getVehicleAccidentById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.VehicleAccident}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

const insertVehicleAccident = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.VehicleAccident,
    input
  );
  return data;
};

const updateVehicleAccident = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.VehicleAccident,
    input
  );
  return data;
};

const deleteVehicleAccident = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.VehicleAccident}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

export const useVehicleAccidentCategoriesQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.VehicleAccident],
    queryFn: () => getVehicleAccidentCategories(input),
    refetchOnWindowFocus: false,
  });
};

export const useGetVehicleAccidentByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.VehicleAccident],
    queryFn: () => getVehicleAccidentById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertVehicleAccidentMutation = () => {
  return useMutation({
    mutationFn: insertVehicleAccident,
  });
};

export const useUpdateVehicleAccidentMutation = () => {
  return useMutation({
    mutationFn: updateVehicleAccident,
  });
};

export const useDeleteVehicleAccidentMutation = () => {
  return useMutation({
    mutationFn: deleteVehicleAccident,
  });
};
